<template>
  <div class="product__cans-flavour-row__inner">
    <slot
      :item="item"
      :link="link"
      :linked="linked"
      :select="select"
      :activate="activate"
      :tile="tile"
      :visible="visible"
    />
  </div>
</template>

<script>
import { cansOptionSelect } from '../../helpers/cans-option-select'

export default {
  name: 'CansFlavourRow',

  mixins: [cansOptionSelect],

  itemClass: 'product__cans-flavour-row__item',

  methods: {
    tile (position, optionValueId) {
      return this.cell(position, optionValueId)?.image || {}
    },

    visible (position, optionValueId, ssrHidden) {
      if (!this.cansLive) return !ssrHidden
      return !this.cansCell(position, optionValueId)?.hidden
    },
  },
}
</script>
